'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hasEllipses = function (ref) {
    var tolerance = 3; // In px. Depends on the font you are using
    var node = ref.current || { offsetWidth: -10, scrollWidth: 0 };
    return node.offsetWidth + tolerance < node.scrollWidth;
};

exports.hasEllipses = hasEllipses;
